export const ADD = 'app/EditSessionPage/ThirdParty/ADD';
export const UPDATE_ANSWER = 'app/EditSessionPage/ThirdParty/UPDATE';
export const REMOVE = 'app/EditSessionPage/ThirdParty/REMOVE';
export const REORDER = 'app/EditSessionPage/ThirdParty/REORDER';
